import LegalDataSection from "../sections/LegalDataSection";
import ClassificationSection from "../sections/ClassificationSection";
import AddressSection from "../sections/AddressSection";
import GeolocationSection from "../sections/GeolocationSection";
import ContactSection from "../sections/ContactSection";
import OwnerSection from "../sections/OwnerSection";
import { useFormContext } from "react-hook-form";

interface GeneralDataFormProps {
  readOnly?: boolean;
  mode?: "create" | "edit" | "view";
}

// Make sure each section component accepts the readOnly prop
const GeneralDataForm = ({ readOnly = false, mode }: GeneralDataFormProps) => {
  const { getValues } = useFormContext();

  return (
    <div className="space-y-6">
      <LegalDataSection mode={mode}/> 
      <ClassificationSection mode={mode} />
      <AddressSection />
      <GeolocationSection />
      <ContactSection />
      <OwnerSection />
    </div>
  );
};

export default GeneralDataForm;
